var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCrossIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9974 24.666C14.3224 24.666 11.3307 21.6743 11.3307 17.9993C11.3307 14.3243 14.3224 11.3327 17.9974 11.3327C21.6724 11.3327 24.6641 14.3243 24.6641 17.9993C24.6641 21.6743 21.6724 24.666 17.9974 24.666ZM17.9974 9.66602C13.3891 9.66602 9.66406 13.391 9.66406 17.9993C9.66406 22.6077 13.3891 26.3327 17.9974 26.3327C22.6057 26.3327 26.3307 22.6077 26.3307 17.9993C26.3307 13.391 22.6057 9.66602 17.9974 9.66602ZM20.1557 14.666L17.9974 16.8243L15.8391 14.666L14.6641 15.841L16.8224 17.9993L14.6641 20.1577L15.8391 21.3327L17.9974 19.1743L20.1557 21.3327L21.3307 20.1577L19.1724 17.9993L21.3307 15.841L20.1557 14.666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCrossIcon);
export default __webpack_public_path__ + "static/media/newCrossIcon.15686dafb3115667bfefd45bc1b590af.svg";
export { ForwardRef as ReactComponent };